import React, { useEffect, useState, useContext, useMemo } from "react";
import { Animated } from "react-animated-css";
import { AuthContext } from "./../index";
import { Form, Input, Checkbox, Select, Radio, Spin, message } from "antd";
import moment from "moment";
import Idate from "./../../../assets/suc-khoe-vang/idate.png";
import IconItem from "./../../../assets/suc-khoe-vang/iconitempacked.png";
import DatePicker from "../modal/DatePicker";
import ModalBenifits from "./../modal/modalBenifit";
import Helper from "./../../../extra/helper";

const mapKeyIsu = {
  buyerName: "insuredName",
  dob: "insuredDob",
  buyerGender: "insuredGender",
};

const Benefits = () => {
  const {
    listIsu,
    setListIsu,
    ActionList,
    dataIsu,
    setDataIsu,
    packages,
    arrItem,
    setDataGetFees,
    dataGetFees,
    loading,
  } = useContext(AuthContext);
  const [datePicker, setDatePicker] = useState({});
  const [form] = Form.useForm();
  const formRef = React.createRef();
  const [formData, setFormData] = useState({});
  const [openBenifits, setOpenBenifits] = useState(false);
  const { Option } = Select;

  useEffect(() => {
    window.scrollTo(0, 0);
    if (dataIsu) {
      if (listIsu.length > 0) {
        const data = {
          buyerName: listIsu[0].insuredName,
          dob: listIsu[0].insuredDob,
          buyerGender: listIsu[0].insuredGender,
        };
        form.setFieldsValue({ ...dataIsu, ...data });
        setFormData({ ...dataIsu, ...data });
      } else {
        form.setFieldsValue(dataIsu);
        setFormData(dataIsu);
      }
    }
  }, []);

  const onFinish = (val) => {
    form
      .validateFields()
      .then(async (values) => {
        setOpenBenifits(true);
        if (
          listIsu?.length > 0 &&
          +listIsu[0]?.relationshipWithBuyerName !== 1
        ) {
          values.buyerName = dataIsu.buyerName;
          values.dob = dataIsu.buyerDob;
          values.buyerDob =
            Helper._calculateAge(dataIsu.buyerDob) >= 18
              ? dataIsu.buyerDob
              : "";
          values.buyerGender = dataIsu.buyerGender;
        }
        setDataIsu({
          ...dataIsu,
          ...values,
          packageId: val,
          buyerDob:
            Helper._calculateAge(values?.dob || values?.buyerDob) >= 18
              ? values?.dob || values?.buyerDob
              : "",
        });
        localStorage.setItem(
          "dataIsuVbiCare",
          JSON.stringify({ ...dataIsu, ...values })
        );
      })
      .catch((err) => {
        // console.error('err:', err);
      });
  };

  const onChangForm = ({ data, name }) => {
    setFormData({
      ...formData,
      [name]: data,
    });
    if (listIsu.length > 0) {
      const key = mapKeyIsu[name];
      if (key) {
        ActionList("edit", 0, {
          ...listIsu[0],
          [key]: data,
        });
      }
    }
  };

  const handCancel = () => {
    setOpenBenifits(false);
  };

  useEffect(() => {
    var dob = Helper.tinhTuoiVaNgayDuRa(
      formData?.dob?.split("/").reverse().join("-")
    );
    setDataGetFees({
      ...dataGetFees,
      buyerName: formData?.buyerName,
      dob: formData?.dob,
      buyerGender: formData?.buyerGender,
      additional_01: +formData?.buyerGender === 1 ? 2 : formData?.additional_01,
      additional_02: formData?.additional_02,
      additional_03: formData?.additional_03,
      additional_04: formData?.additional_04,
      // additional_05: 1,
    });
    setTimeout(() => {
      if (formData?.buyerGender === 2 && (+dob.tuoi < 19 || +dob?.tuoi > 50)) {
        form.resetFields(["additional_01"]);
        setDataGetFees({
          ...dataGetFees,
          buyerName: formData?.buyerName,
          dob: formData?.dob,
          buyerGender: formData?.buyerGender,
          additional_01: 2,
          additional_02: formData?.additional_02,
          additional_03: formData?.additional_03,
          additional_04: formData?.additional_04,
          // additional_05: 1,
        });
        return;
      }
    }, 500);
  }, [formData]);

  return (
    <>
      <ModalBenifits
        formData={formData}
        open={openBenifits}
        handleCancel={handCancel}
      />
      {datePicker.open && (
        <DatePicker
          onConfirm={(data) => {
            form.setFieldsValue({
              [datePicker.name]: data,
            });
            onChangForm({ data: data, name: datePicker.name });
          }}
          max={datePicker.name === "dob" ? moment().subtract(62, "d").toDate() : undefined}
          min={datePicker.name === "dob" ? moment().subtract(65, "y").add(0, "days").toDate() : new Date()}
          visible={datePicker.open}
          close={() => {
            setDatePicker({ ...datePicker, open: false });
          }}
          value={formData[datePicker.name]}
          title={datePicker.name === "dob" ? "Ngày sinh" : "Ngày hiệu lực"}
        />
      )}
      <Form
        style={{ fontSize: 14, color: "#343A40" }}
        ref={formRef}
        form={form}
        onFinish={onFinish}
        name="step2skv"
        scrollToFirstError
      >
        <div style={{ background: "#F1F1F1", minHeight: "100vh" }}>
          <div
            style={{
              background: "#ffffff",
              padding: 10,
              // position: "sticky",
              // top: 0,
              // zIndex: 1,
            }}
          >
            <div style={{ fontSize: 14, color: "#FB7800" }}>
              Vui lòng chọn ngày sinh người được bảo hiểm để xem gói bảo hiểm
              phù hợp.
            </div>
            {/* <div style={{ marginTop: 10 }}>
              <div>
                Họ và tên<span style={{ color: "red" }}>*</span>
              </div>
              <Form.Item
                name="buyerName"
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập thông tin",
                  },
                ]}
                style={css.FormItemsHolder}
              >
                <Input
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      buyerName: e.target.value,
                    });
                    onChangForm({ data: e.target.value, name: "buyerName" });
                  }}
                  autoComplete="off"
                  style={{ ...css.input, textTransform: "capitalize" }}
                  placeholder="Nhập họ và tên"
                />
              </Form.Item>
            </div> */}
            <div style={{ display: "flex", flexDirection: "row", gap: 8 }}>
              <div style={{ marginTop: 10, flex: 1 }}>
                <div>
                  Ngày sinh<span style={{ color: "red" }}>*</span>
                </div>
                <Form.Item
                  name="dob"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng nhập thông tin",
                    },
                  ]}
                  style={css.FormItemsHolder}
                >
                  <Input
                    autoComplete="off"
                    suffix={
                      <img style={{ width: 18 }} src={Idate} alt="Global Care" />
                    }
                    readOnly
                    style={{ ...css.input }}
                    placeholder="DD/MM/YYYY"
                    onClick={() => {
                      setDatePicker({ ...datePicker, open: true, name: "dob" });
                    }}
                  />
                </Form.Item>
              </div>
              <div style={{ marginTop: 10, flex: 1 }}>
                <div>
                  Giới tính<span style={{ color: "red" }}>*</span>
                </div>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng nhập thông tin",
                    },
                  ]}
                  name="buyerGender"
                  style={{ ...css.FormItemsHolder, margin: 0 }}
                >
                  <Radio.Group
                    onChange={(e) => {
                      if (e.target.value === 1) {
                        form.resetFields(["additional_01"]);
                        setFormData({
                          ...formData,
                          buyerGender: 1,
                          additional_01: 2,
                        });
                        // setTimeout(() => {
                        //   setDataGetFees({
                        //     ...dataGetFees,
                        //     additional_01: 2,
                        //     buyerGender: 1,
                        //   });
                        // }, 100);
                        return;
                      }
                      onChangForm({ data: e.target.value, name: "buyerGender" });
                    }}
                  >
                    <Radio value={1}>Nam</Radio>
                    <Radio value={2}>Nữ</Radio>
                  </Radio.Group>
                </Form.Item>
              </div>
            </div>

            <div
              style={{
                marginTop: 10,
                display: "flex",
                justifyContent: "between",
                gap: 10,
                alignItems: "start",
              }}
            >
              <div style={{ width: "50%" }}>
                <div>
                  Ngày bắt đầu<span style={{ color: "red" }}>*</span>
                </div>
                <Form.Item
                  name="beginDate"
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng nhập thông tin",
                    },
                  ]}
                  style={css.FormItemsHolder}
                >
                  <Input
                    autoComplete="off"
                    suffix={
                      <img
                        style={{ width: 18 }}
                        src={Idate}
                        alt="Global Care"
                      />
                    }
                    readOnly
                    style={{ ...css.input }}
                    placeholder="DD/MM/YYYY"
                    onClick={() => {
                      setDatePicker({ ...datePicker, open: true, name: "beginDate" });
                    }}
                  />
                </Form.Item>
              </div>
              <div style={{ width: "50%" }}>
                <div style={{ marginBottom: 5 }}>
                  Ngày kết thúc<span style={{ color: "red" }}>*</span>
                </div>
                <Input
                  autoComplete="off"
                  value={form.getFieldValue("beginDate") ? moment(form.getFieldValue("beginDate"), "DD/MM/YYYY").add(1, "year").format("DD/MM/YYYY") : "DD/DD/YYYY"}
                  suffix={
                    <img
                      style={{ width: 18 }}
                      src={Idate}
                      alt="Global Care"
                    />
                  }
                  disabled
                  style={{ ...css.input }}
                  placeholder="DD/MM/YYYY"
                />
              </div>
            </div>

            <div style={{ fontWeight: 600, marginTop: 10 }}>
              Quyền lợi bổ sung:
            </div>
            <div style={{ marginTop: 10 }}>
              <Form.Item name="additional_01" style={css.FormItemsHolder}>
                <Checkbox.Group
                  onChange={(e) => {
                    onChangForm({ data: e[0], name: "additional_01" });
                  }}
                >
                  <Checkbox
                    disabled={
                      formData.buyerGender === 1 ||
                        +Helper.tinhTuoiVaNgayDuRa(
                          formData?.dob?.split("/").reverse().join("-")
                        )?.tuoi < 19 ||
                        +Helper.tinhTuoiVaNgayDuRa(
                          formData?.dob?.split("/").reverse().join("-")
                        )?.tuoi > 50
                        ? true
                        : false
                    }
                    value={1}
                  >
                    Thai sản (Không bao gồm chi phí khám thai định kỳ, áp dụng
                    đồng chi trả)
                  </Checkbox>
                </Checkbox.Group>
              </Form.Item>
            </div>

            <div>
              <Form.Item name="additional_02" style={css.FormItemsHolder}>
                <Checkbox.Group
                  onChange={(e) => {
                    onChangForm({ data: e[0], name: "additional_02" });
                  }}
                >
                  <Checkbox value={1}>Bảo hiểm điều trị ngoại trú</Checkbox>
                </Checkbox.Group>
              </Form.Item>
            </div>

            <div>
              <Form.Item name="additional_03" style={css.FormItemsHolder}>
                <Checkbox.Group
                  onChange={(e) => {
                    onChangForm({ data: e[0], name: "additional_03" });
                  }}
                >
                  <Checkbox value={1}>Nha khoa (áp dụng đồng chi trả)</Checkbox>
                </Checkbox.Group>
              </Form.Item>
            </div>
            <div>
              <Form.Item name="additional_04" style={css.FormItemsHolder}>
                <Checkbox.Group
                  onChange={(e) => {
                    onChangForm({ data: e[0], name: "additional_04" });
                  }}
                >
                  <Checkbox value={1}>
                    Trợ cấp nằm viện do tai nạn ( tối đa 60 ngày/năm)
                  </Checkbox>
                </Checkbox.Group>
              </Form.Item>
            </div>
            {/* <div>
              <Form.Item name="additional_05" style={css.FormItemsHolder}>
                <Checkbox.Group
                  onChange={(e) => {
                    onChangForm({ data: e[0], name: "additional_05" });
                  }}
                >
                  <Checkbox value={1}>Dịch vụ bảo lãnh viện phí</Checkbox>
                </Checkbox.Group>
              </Form.Item>
            </div> */}
          </div>
          {loading && (
            <div style={{ padding: 10 }}>
              <div style={{ textAlign: "center" }}>
                <Spin />
                <div>Đang tìm gói bảo hiểm phù hợp....</div>
              </div>
            </div>
          )}
          <div style={{ padding: 10 }}>
            {(arrItem || []).map((data, i) => (
              <Animated
                animationIn="slideInUp"
                // animationOut="zoomOutDown"
                animationInDuration={i * 300}
                animationOutDuration={i * 300}
                isVisible={!loading}
                style={{ display: +data?.fee > 0 ? "" : "none" }}
              >
                <div
                  onClick={() => {
                    if (data.id === 1) {
                      message.warning(
                        {
                          content:
                            "Gói đồng chỉ hỗ trợ quyền lợi trợ cấp quyền lợi cho tai nạn!",
                          style: {
                            marginTop: "40vh",
                          },
                        },
                        120
                      );
                    }
                    onFinish(data.id);
                  }}
                  key={i}
                  style={{
                    padding: "13px 16px",
                    background: "#ffffff",
                    borderRadius: 8,
                    alignItems: "center",
                    marginBottom: 10,
                    display: packages.length > 0 ? "" : "none",
                  }}
                >
                  <div
                    style={{
                      marginTop: -10,
                      marginLeft: -10,
                      display: +dataIsu?.packageId - 1 === i ? "" : "none",
                    }}
                  >
                    <img src={IconItem} style={{ width: 15, height: 15 }} />
                  </div>
                  <div
                    style={{
                      display: "flex",
                    }}
                  >
                    <div style={{ marginRight: 10 }}>
                      <img src={data.icon} style={{ width: 67, height: 71 }} />
                    </div>
                    <div style={{ width: "100%" }}>
                      <div style={{ fontWeight: 600, color: "#009B4B" }}>
                        {data.title}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span>Phí bảo hiểm:</span>
                        <span style={{ fontWeight: 500, color: "#009B4B" }}>
                          {Helper._formatMoney(data.fee)} VNĐ
                        </span>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <span>Số tiền BH</span>
                        <span>
                          {Helper._formatMoney(data?.insuranceMoney)} VNĐ
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Animated>
            ))}
          </div>
        </div>
      </Form>
    </>
  );
};

const css = {
  btnNext: {
    color: "#FFF",
    background: "#009B4B",
    fontWeight: "bold",
    width: "48%",
    height: "44px",
    borderRadius: 8,
  },
  btnBack: {
    color: "#009B4B",
    background: "#FFF",
    fontWeight: "bold",
    width: "48%",
    height: "44px",
    borderRadius: 8,
    border: "1px solid #009B4B",
  },
  FormItemsHolder: {
    width: "100%",
    borderRadius: 8,
    margin: "5px 0px",
    padding: 0,
  },
  vnđ: {
    height: 30,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 8,
    position: "absolute",
    right: 10,
    top: 6,
    cursor: "pointer",
    fontSize: 14,
  },
  inputNumber: {
    width: "100%",
    borderRadius: 8,
    padding: "5px 0px",
    position: "relative",
    fontWeight: "bold",
    fontSize: 14,
    // color: "#0B3C8A",
    border: "1px solid #DCDCDC",
  },
  input: { borderRadius: 8, padding: 10, fontSize: 14, color: "#343A40" },
  btnxemql: {
    background: "#009B4B",
    fontWeight: 600,
    color: "#ffffff",
    height: 40,
    width: 226,
    borderRadius: 42,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0px auto",
    boxShadow: "0px 4px 4px 0px #00000040",
    marginTop: 10,
    cursor: "pointer",
  },
  driver: {
    width: "100%",
    height: 5,
    background: "#0000001A",
    marginTop: 10,
  },
  title: {
    fontSize: 16,
    color: "#009B4B",
    fontWeight: 600,
    // marginTop: 10,
  },
  box: {
    padding: 10,
    borderRadius: 8,
    border: "1px solid #009B4B",
  },
  item: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 5,
  },
  itemleft: {
    color: "#646D69",
    display: "flex",
    alignItems: "flex-start",
  },
  itemright: { fontWeight: 600, width: 110, textAlign: "right" },
  boxbtn: {
    display: "flex",
    justifyContent: "space-between",
    position: "sticky",
    bottom: 0,
    height: 76,
    background: "#fff",
    borderRadius: "16px 16px 0px 0px",
    display: "flex",
    alignItems: "center",
    boxShadow: "0px -4px 8px 0px #0000001A",
    padding: "0px 10px",
  },
  cham: { fontSize: 20, marginRight: 5, marginTop: -5 },
};

export default Benefits;
